import { render, staticRenderFns } from "./ArticleLabourCostCard.vue?vue&type=template&id=261f4986"
import script from "./ArticleLabourCostCard.vue?vue&type=script&lang=ts"
export * from "./ArticleLabourCostCard.vue?vue&type=script&lang=ts"
import style0 from "./ArticleLabourCostCard.vue?vue&type=style&index=0&id=261f4986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports